<template>
  <div class="not-found">
    <div class="not-found__card">
      <h1 class="not-found__title">
        This page doesn't exist
      </h1>
      <p class="not-found__body">
        The link may be old, or slightly mistyped. Nothing you saved is
        affected.
      </p>

      <div class="not-found__links">
        <router-link to="/"
class="not-found__link">Home</router-link>
        <router-link to="/features"
class="not-found__link">Features</router-link>
        <router-link to="/faq"
class="not-found__link">FAQ</router-link>
        <router-link to="/contact"
class="not-found__link">Contact</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFoundView',
}
</script>

<style lang="scss" scoped>
.not-found {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 64px 24px;
}

.not-found__card {
  max-width: 480px;
  width: 100%;
  text-align: center;
}

.not-found__title {
  margin: 0 0 12px;
  font-size: 28px;
  line-height: 1.3;
}

.not-found__body {
  margin: 0 0 28px;
  font-size: 15px;
  line-height: 1.55;
  color: var(--bzioup-text-color-soft, #777);
}

.not-found__links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 20px;
  justify-content: center;
}

.not-found__link {
  font-size: 14px;
  color: var(--bzioup-text-color, #333);
  text-decoration: none;
  border-bottom: solid 2px var(--bzioup-color-pink);
  padding-bottom: 2px;

  &:hover { color: var(--bzioup-color-pink); }
}
</style>
